<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: { Layout },
  data() {
    return {
      item: null,
      loading: true,
      uploadLoading: false,
      file: null,
    };
  },
  computed: {
    payId() {
      return this.$route.params.id;
    },
    canUploadInvoice() {
      if (!this.item) return false;
      return (
        this.item.person_type === "legal" &&
        String(this.item.status) === "3"
      );
    },
    statusLabel() {
      if (!this.item) return "";
      const s = String(this.item.status);
      if (s === "0") return "Aguardando processamento";
      if (s === "1") return "Pago";
      if (s === "2") return "Recusado";
      if (s === "3") return "Aguardando validação da NF";
      return s;
    },
    taxesInss() {
      if (!this.item || this.item.person_type === "legal") return 0;
      const n = parseFloat(this.item.inss);
      return Number.isFinite(n) ? n : 0;
    },
  },
  methods: {
    load() {
      this.loading = true;
      api
        .get("wallet/withdrawal")
        .then((res) => {
          if (res.data.status === "success" && Array.isArray(res.data.list)) {
            this.item = res.data.list.find(
              (row) => String(row.id) === String(this.payId)
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onFile(e) {
      const f = e.target.files && e.target.files[0];
      this.file = f || null;
    },
    uploadInvoice() {
      if (!this.file) {
        this.$toast.error("Selecione o arquivo da nota fiscal.");
        return;
      }
      this.uploadLoading = true;
      const fd = new FormData();
      fd.append("file", this.file);
      api
        .postFormData("wallet/withdrawal/" + this.payId + "/invoice", fd)
        .then((res) => {
          if (res.data.status === "success") {
            this.$toast.success(res.data.message || "Nota enviada.");
            this.file = null;
            this.load();
          } else {
            this.$toast.error(res.data.message || "Falha no envio.");
          }
        })
        .finally(() => {
          this.uploadLoading = false;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">Início</router-link>
      </li>
      <li class="breadcrumb-item">
        <router-link tag="a" to="/wallet/extract">Financeiro</router-link>
      </li>
      <li class="breadcrumb-item">
        <router-link tag="a" to="/wallet/withdrawal/history">Saques</router-link>
      </li>
      <li class="breadcrumb-item d-none d-sm-block">Detalhe</li>
    </ol>

    <div class="card" v-if="loading">
      <div class="card-body">Carregando…</div>
    </div>

    <div class="card" v-else-if="!item">
      <div class="card-body">Saque não encontrado.</div>
    </div>

    <div class="card" v-else>
      <div class="card-body">
        <h4>Saque #{{ item.id }}</h4>
        <p class="mb-1"><strong>Data:</strong> {{ item.date }}</p>
        <p class="mb-1"><strong>Valor bruto:</strong> {{ item.value | currency }}</p>
        <p class="mb-1"><strong>Taxa:</strong> {{ item.fee | currency }}</p>
        <p class="mb-1"><strong>Impostos:</strong> {{ taxesInss | currency }}</p>
        <p class="mb-1"><strong>Valor líquido:</strong> {{ item.transfered | currency }}</p>
        <p class="mb-1"><strong>Status:</strong> {{ statusLabel }}</p>
        <p class="mb-1" v-if="item.person_type === 'legal'">
          <strong>Tipo:</strong> Pessoa jurídica
        </p>
        <p class="mb-1" v-if="item.invoice_url">
          <a :href="item.invoice_url" target="_blank" rel="noopener">Nota fiscal enviada</a>
        </p>

        <div v-if="canUploadInvoice" class="mt-4 border-top pt-3">
          <h5>Enviar nota fiscal</h5>
          <p class="text-muted small">
            Envie o PDF ou imagem da NF de prestação de serviço.
          </p>
          <b-form-file accept=".pdf,.jpg,.jpeg,.png,.webp" @change="onFile" class="mb-2" />
          <b-button
            variant="default"
            :disabled="uploadLoading"
            @click="uploadInvoice"
          >
            Enviar
          </b-button>
        </div>
      </div>
    </div>
  </Layout>
</template>
